import script from "./editPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./editPassword.vue?vue&type=script&setup=true&lang=js"

import "./editPassword.vue?vue&type=style&index=0&id=3767dd1e&lang=scss&scoped=true"

import exportComponent from "/Users/ioblabs/work/weina/production/weina_oms_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3767dd1e"]])

export default __exports__